import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconBuildingSvg } from "./IconBuildingSvg.mjs";
const IconBuilding = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconBuildingSvg, ...iconProps });
};
export {
  IconBuilding
};
